// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import SpotRed from '../_raw/ui/icon_spot_red.svg';
import withIconProps from '../withIconProps';

export default withIconProps(SpotRed);
